// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../styles/colors.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("styles/img/icon_close--gray.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles__inner___JdMkT {
  position: relative;
}

.styles__close___cfd4d {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center;
  background-size: contain;
  cursor: pointer;
  display: none;
  height: 20px;
  position: absolute;
  right: 0;
  top: 0;
  width: 20px;
}

.modal-enter {
    bottom: 0;
    left: 0;
    opacity: 0;
    position: fixed;
    right: 0;
    top: 0;
    transition: opacity 200ms ease-in;
    z-index: 9997;
  }

.modal-enter .modal {
      transform: scale(0.85);
    }

.modal-enter.modal-enter-active {
    opacity: 1;
  }

.modal-enter.modal-enter-active .modal {
      transform: scale(1);
    }

.modal-leave {
    bottom: 0;
    left: 0;
    opacity: 1;
    position: fixed;
    right: 0;
    top: 0;
    transition: opacity 200ms ease-in;
    z-index: 9997;
  }

.modal-leave .modal {
      transform: scale(1);
    }

.modal-leave.modal-leave-active {
    opacity: 0;
  }

.modal-leave.modal-leave-active .modal {
      transform: scale(0.85);
    }

.overlay {
    background-color: rgba(0, 0, 0, 0.5);
    bottom: 0;
    cursor: pointer;
    left: 0;
    position: fixed;
    right: 0;
    top: 0;
    z-index: 9998;
  }

.modal {
    background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBackground"]};
    border-radius: 4px;
    bottom: 0;
    box-shadow: 0 0 3px 1px rgba(0, 0, 0, 0.2);
    left: 0;
    margin: auto;
    max-height: 90%;
    max-width: 90%;
    overflow: auto;
    padding: 20px;
    position: fixed;
    right: 0;
    top: 0;
    transition: all 200ms;
    width: 925.72px;
    z-index: 9999;
  }

.styles__modal-transition-enter___GCNPZ {
  opacity: 0;
  transform: translateX(-100%);
}
.styles__modal-transition-enter-active___dSV__ {
  opacity: 1;
  transform: translateX(0);
  transition: opacity 300ms, transform 300ms;
}
.styles__modal-transition-exit___yIb4s {
  opacity: 1;
  transform: translateX(0);
}
.styles__modal-transition-exit-active___EaqM0 {
  opacity: 0;
  transform: translateX(-100%);
  transition: opacity 300ms, transform 300ms;
}
`, "",{"version":3,"sources":["webpack://./universal/components/Modal/styles.css"],"names":[],"mappings":"AAIA;EACE,kBAAkB;AACpB;;AAEA;EACE,oEAAmE;EACnE,wBAAwB;EACxB,eAAe;EACf,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,WAAW;AACb;;AAGE;IACE,SAAS;IACT,OAAO;IACP,UAAU;IACV,eAAe;IACf,QAAQ;IACR,MAAM;IACN,iCAAiC;IACjC,aAAa;EAKf;;AAHE;MACE,sBAAsB;IACxB;;AAGF;IACE,UAAU;EAKZ;;AAHE;MACE,mBAAmB;IACrB;;AAGF;IACE,SAAS;IACT,OAAO;IACP,UAAU;IACV,eAAe;IACf,QAAQ;IACR,MAAM;IACN,iCAAiC;IACjC,aAAa;EAKf;;AAHE;MACE,mBAAmB;IACrB;;AAGF;IACE,UAAU;EAKZ;;AAHE;MACE,sBAAsB;IACxB;;AAGF;IACE,oCAAoC;IACpC,SAAS;IACT,eAAe;IACf,OAAO;IACP,eAAe;IACf,QAAQ;IACR,MAAM;IACN,aAAa;EACf;;AAEA;IACE,wDAAwB;IACxB,kBAAkB;IAClB,SAAS;IACT,0CAA0C;IAC1C,OAAO;IACP,YAAY;IACZ,eAAe;IACf,cAAc;IACd,cAAc;IACd,aAAa;IACb,eAAe;IACf,QAAQ;IACR,MAAM;IACN,qBAAqB;IACrB,eAAe;IACf,aAAa;EACf;;AAGF;EACE,UAAU;EACV,4BAA4B;AAC9B;AACA;EACE,UAAU;EACV,wBAAwB;EACxB,0CAA0C;AAC5C;AACA;EACE,UAAU;EACV,wBAAwB;AAC1B;AACA;EACE,UAAU;EACV,4BAA4B;EAC5B,0CAA0C;AAC5C","sourcesContent":["@value colors: \"styles/colors.css\";\n@value helpers: \"styles/helpers.css\";\n@value gtBlue, gtGrayLight, gtBackground, gtGray from colors;\n\n.inner {\n  position: relative;\n}\n\n.close {\n  background: url('styles/img/icon_close--gray.png') no-repeat center;\n  background-size: contain;\n  cursor: pointer;\n  display: none;\n  height: 20px;\n  position: absolute;\n  right: 0;\n  top: 0;\n  width: 20px;\n}\n\n:global {\n  .modal-enter {\n    bottom: 0;\n    left: 0;\n    opacity: 0;\n    position: fixed;\n    right: 0;\n    top: 0;\n    transition: opacity 200ms ease-in;\n    z-index: 9997;\n\n    .modal {\n      transform: scale(0.85);\n    }\n  }\n\n  .modal-enter.modal-enter-active {\n    opacity: 1;\n\n    .modal {\n      transform: scale(1);\n    }\n  }\n\n  .modal-leave {\n    bottom: 0;\n    left: 0;\n    opacity: 1;\n    position: fixed;\n    right: 0;\n    top: 0;\n    transition: opacity 200ms ease-in;\n    z-index: 9997;\n\n    .modal {\n      transform: scale(1);\n    }\n  }\n\n  .modal-leave.modal-leave-active {\n    opacity: 0;\n\n    .modal {\n      transform: scale(0.85);\n    }\n  }\n\n  .overlay {\n    background-color: rgba(0, 0, 0, 0.5);\n    bottom: 0;\n    cursor: pointer;\n    left: 0;\n    position: fixed;\n    right: 0;\n    top: 0;\n    z-index: 9998;\n  }\n\n  .modal {\n    background: gtBackground;\n    border-radius: 4px;\n    bottom: 0;\n    box-shadow: 0 0 3px 1px rgba(0, 0, 0, 0.2);\n    left: 0;\n    margin: auto;\n    max-height: 90%;\n    max-width: 90%;\n    overflow: auto;\n    padding: 20px;\n    position: fixed;\n    right: 0;\n    top: 0;\n    transition: all 200ms;\n    width: 925.72px;\n    z-index: 9999;\n  }\n}\n\n.modal-transition-enter {\n  opacity: 0;\n  transform: translateX(-100%);\n}\n.modal-transition-enter-active {\n  opacity: 1;\n  transform: translateX(0);\n  transition: opacity 300ms, transform 300ms;\n}\n.modal-transition-exit {\n  opacity: 1;\n  transform: translateX(0);\n}\n.modal-transition-exit-active {\n  opacity: 0;\n  transform: translateX(-100%);\n  transition: opacity 300ms, transform 300ms;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colors": `"styles/colors.css"`,
	"helpers": `"styles/helpers.css"`,
	"gtBlue": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlue"]}`,
	"gtGrayLight": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGrayLight"]}`,
	"gtBackground": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBackground"]}`,
	"gtGray": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGray"]}`,
	"inner": `styles__inner___JdMkT`,
	"close": `styles__close___cfd4d`,
	"modal-transition-enter": `styles__modal-transition-enter___GCNPZ`,
	"modal-transition-enter-active": `styles__modal-transition-enter-active___dSV__`,
	"modal-transition-exit": `styles__modal-transition-exit___yIb4s`,
	"modal-transition-exit-active": `styles__modal-transition-exit-active___EaqM0`
};
export default ___CSS_LOADER_EXPORT___;
